import { useDappPublish } from '../../hooks/useDappPublish';
import { Button } from '../ui/button';

interface DappPublishSectionProps {
  dappId: string;
  storeStatus: 'published' | 'unpublished' | null | undefined;
  onPublished?: () => void;
}

/**
 * Shows the Store's current publication state and publishes an approved Portal
 * app through the Store's idempotent endpoint.
 */
export function DappPublishSection({
  dappId,
  storeStatus,
  onPublished,
}: DappPublishSectionProps) {
  const { isPublishing, handlePublish } = useDappPublish(dappId, onPublished);
  const isPublished = storeStatus === 'published';
  const message = isPublished
    ? 'This app is published on the dApp Store.'
    : storeStatus === null
      ? 'This app has not been ingested by the dApp Store yet.'
      : 'Publish this app to the dApp Store.';
  const label = isPublishing
    ? '…'
    : isPublished
      ? 'Published'
      : storeStatus === null
        ? 'Not ingested'
        : storeStatus === undefined
          ? '…'
          : 'Publish';

  return (
    <div className="flex flex-col gap-2 border-t border-white/5 pt-5">
      <p className="text-xs text-neutral-400">{message}</p>
      <div className="flex items-center gap-1.5">
        <Button
          type="button"
          size="sm"
          className="h-8 shrink-0 rounded-lg border border-teal-400/30 bg-teal-500/15 px-3 text-xs font-medium text-teal-200 transition-colors hover:border-teal-400/50 hover:bg-teal-500/25 disabled:cursor-not-allowed disabled:opacity-40"
          disabled={isPublishing || storeStatus !== 'unpublished'}
          onClick={() => {
            void handlePublish();
          }}
        >
          {label}
        </Button>
      </div>
    </div>
  );
}
